import createItem from './createItem';
import updateItem from './updateItem';

export default (filterData, values) => (dispatch) => {
    let newValues = {
        code: values.code,
        cost: values.cost,
        data_sheet_name: values.datasheet_name,
        name: values.name,
        weight: values.weight,
    };

    if (Array.isArray(values.datasheet_archive)) {
        newValues.data_sheet =
            values.datasheet_archive && values.datasheet_archive[0];
    }

    if (Array.isArray(values.image_thumbnail)) {
        newValues.image_thumbnail =
            values.image_thumbnail && values.image_thumbnail[0];
    }

    if (values.id) dispatch(updateItem(filterData, newValues, values.id));
    else dispatch(createItem(filterData, newValues));
};
